// auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { catchError, map, of, switchMap } from 'rxjs';
import { AccountInfoService } from '../services/account-info.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const msalGuard = inject(MsalGuard);
  const accountInfoService = inject(AccountInfoService);
  const router = inject(Router);
  const requiredRoles = ['surveys.user', 'surveys.admin'];

  return msalGuard.canActivate(route, state).pipe(
    switchMap((isAuthed) => {
      if (isAuthed) {
        return accountInfoService.loadAccountInfo().pipe(
          map((accountInfo) => {
            if (accountInfoService.hasAnyRole(requiredRoles)) {
              return true;
            } else {
              return router.parseUrl('/access-denied');
            }
          }),
          catchError(() => of(router.parseUrl('/access-denied')))
        );
      } else {
        return of(router.parseUrl('/access-denied'));
      }
    })
  );
};
